/* eslint-disable @hhgtech/hhg-customs/img-require-loading */
/* eslint-disable @next/next/no-sync-scripts */
import Head from 'next/head'

export const PrePageTrackingScript = () => {
  return (
    <>
      <Head>
        {/* <!-- Google floodlight snippet --> */}
        <script
          key="special-spotlight-tracking"
          async
          src="https://www.googletagmanager.com/gtag/js?id=DC-12730486"
        />
        <script
          key="special-spotlight-tracking2"
          dangerouslySetInnerHTML={{
            __html: `window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
              
                gtag('config', 'DC-12730486');`,
          }}
        />
      </Head>
      {/* <!-- END Google floodlight snippet --> */}
      <script
        dangerouslySetInnerHTML={{
          __html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '779154057297874');
fbq('track', 'PageView');`,
        }}
      />
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=779154057297874&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>
      {/* <!-- End Meta Pixel Code --> */}
      {/* <!-- Tiktok Code --> */}
      <script
        dangerouslySetInnerHTML={{
          __html: `!function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=[""page"",""track"",""identify"",""instances"",""debug"",""on"",""off"",""once"",""ready"",""alias"",""group"",""enableCookie"",""disableCookie""],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i=""https://analytics.tiktok.com/i18n/pixel/events.js"";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement(""script"");o.type=""text/javascript"",o.async=!0,o.src=i+""?sdkid=""+e+""&lib=""+t;var a=document.getElementsByTagName(""script"")[0];a.parentNode.insertBefore(o,a)};

  ttq.load('CG2R9B3C77UAN2JP7L10');
  ttq.page();
}(window, document, 'ttq');`,
        }}
      />
      {/* <!-- End Tiktok Code --> */}
      {/* <!-- gtag event snippet --> */}
      <script
        dangerouslySetInnerHTML={{
          __html: `gtag('event', 'conversion', {
          'allow_custom_scripts': true,
          'send_to': 'DC-12730486/pagev0/th_ac0+standard'
          });`,
        }}
      />
      <noscript>
        <img
          src="https://ad.doubleclick.net/ddm/activity/src=12730486;type=pagev0;cat=th_ac0;dc_lat=;dc_rdid=${Math.floor(Math.random()*1000000)};tag_for_child_directed_treatment=;tfua=;npa=;gdpr=0;gdpr_consent=;ord=1?"
          width="1"
          height="1"
          alt=""
        />
      </noscript>
      {/* <!-- END gtag event snippet --> */}
    </>
  )
}

export const PostPageTrackingScript = () => {
  return (
    <>
      <script
        src="https://js.adsrvr.org/up_loader.1.1.0.js"
        type="text/javascript"
      />
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `ttd_dom_ready( function() {
if (typeof TTDUniversalPixelApi === 'function') {
    var universalPixelApi = new TTDUniversalPixelApi();
    universalPixelApi.init("3dc1drw", ["ej4eafq"], "https://insight.adsrvr.org/track/up");
}
});`,
        }}
      />
    </>
  )
}
